<div class="form-group">
    <label class="input-label">Calculate value by field:</label>
    <select class="form-control"
            name="fieldOptions.calculatesharesvalue"
            [(ngModel)]="fieldOptions.calculatesharesvalue"
            (ngModelChange)="dataChangedEvent($event)"
            class="form-control">
        <option value=""></option>
        <option *ngFor="let field of visibleFields" value="{{field.key}}">
            {{field.label}}
        </option>
        <option *ngFor="let guide of visibleGuides" value="{{guide.formIoId}}">
            {{guide.title}}
        </option>
    </select>

</div>